/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Employment_Type_TitleInputs */

const en_reset_employment_type_title = /** @type {(inputs: Reset_Employment_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset employment type`)
};

const de_reset_employment_type_title = /** @type {(inputs: Reset_Employment_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tätigkeit zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset employment type" |
*
* @param {Reset_Employment_Type_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const reset_employment_type_title = /** @type {((inputs?: Reset_Employment_Type_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Employment_Type_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_reset_employment_type_title(inputs)
	return en_reset_employment_type_title(inputs)
});